import React from 'react';
import {
  Navigate,
  Outlet,
} from 'react-router-dom';

import { useAuth } from '../features/auth/AuthContext';
import { ROUTES } from '../config/routes';

import { FullPageLoader } from '../features/system/state/StatePage';

export default function GuestRoute() {
  const {
    status,
    isAuthenticated,
  } = useAuth();

  if (status === 'loading') {
    return <FullPageLoader />;
  }

  if (isAuthenticated) {
    return (
      <Navigate
        to={ROUTES.memberInfo}
        replace
      />
    );
  }

  return <Outlet />;
}